// extracted by mini-css-extract-plugin
module.exports = {"container":"Leaderboard_container__3hIEa","Tab":"Leaderboard_Tab__3S_IW"};